import { CheckCircleIcon } from '@heroicons/react/24/outline';
import PropTypes from 'prop-types';

function StepSuccess({ onClose }) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-12">
      {/* Success Icon */}
      <div className="mb-8">
        <CheckCircleIcon className="h-24 w-24 text-green-500" />
      </div>

      {/* Success Title */}
      <h2 className="mb-6 text-center font-bold text-3xl text-gray-900">
        PFG Request Submitted Successfully!
      </h2>

      {/* Success Message */}
      <div className="mb-8 max-w-2xl text-center">
        <p className="text-gray-600 text-lg">
          Your request will be reviewed within 24 business hours and processed
          for a remake delivery within 7-10 days from submission if it meets the
          requirements. We will reach out to the respective party if any
          additional information is needed.
        </p>
      </div>

      {/* Close Button */}
      <button
        type="button"
        onClick={onClose}
        className="rounded-md border border-transparent bg-green-600 px-6 py-3 font-medium text-white shadow-sm hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
      >
        Close
      </button>
    </div>
  );
}

StepSuccess.propTypes = {
  onClose: PropTypes.func,
};

export default StepSuccess;
